/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class FirmwareApi {
    static getInstance() {
        if (!this.instance) this.instance = new FirmwareApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 飞书登录
    async feishuLogin (param){
        let url = `/api/sys/auth`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取固件列表
    async getFirmwareList (param,num,size){
        let url = `/api/sys/firmware/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 上传固件
    async uploadFirmware (param, env, limit, limitVal, desc, desc_de, desc_fr, desc_nl, desc_et, desc_lv, desc_lt ){
        let url = `/api/sys/firmware?environment=${env}&release_limit=${limit}&release_limit_val=${limitVal}&firmware_desc=${desc}&firmware_desc_de=${desc_de}&firmware_desc_fr=${desc_fr}&firmware_desc_nl=${desc_nl}&firmware_desc_et=${desc_et}&firmware_desc_lv=${desc_lv}&firmware_desc_lt=${desc_lt}`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }
    // 禁用固件文件
    async disableFirmware (fileId){
        let url = `/api/sys/firmware/file/${fileId}/disable`
        let result = await this.getData(url,{},'DELETE')
        return result
    }
    // 从固件文件发布固件
    async uploadPublishFirmware (fileId, param){
        let url = `/api/sys/firmware/file/${fileId}/publish`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

    // 固件文件上传固件
    async firmwareFileUpload (param, sys_org, desc, desc_de, desc_fr, desc_nl, desc_et, desc_lv, desc_lt ){
        let url = `/api/sys/firmware/file/upload?sys_org=${sys_org}&firmware_desc=${desc}&firmware_desc_de=${desc_de}&firmware_desc_fr=${desc_fr}&firmware_desc_nl=${desc_nl}&firmware_desc_et=${desc_et}&firmware_desc_lv=${desc_lv}&firmware_desc_lt=${desc_lt}`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

    // 查询固件文件列表
    async getFirmwareFileList (param){
        let url = `/api/sys/firmware/file/list`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 禁用固件
    async forbiddenFirmware (id){
        let url = `/api/sys/firmware/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取灰度的限制具体值
    async getGrayscale (){
        let url = `/api/sys/grayscale/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取个人的限制具体值
    async getUserQuery (){
        let url = `/api/sys/users/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取基地的限制具体值
    async getBaseQuery (){
        let url = `/api/sys/base/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 查询 SKU 列表
    async getSkuCode (param){
        let url = `/api/sys/v2/vehicle/sku/list`
        let result = await this.getData(url,param,'GET')
        return result
    }
    // 获取车架号/总成编码的限制具体值
    async getFrameNumberOrAssemblyCode (param, page_num , page_size){
        let url = `/api/sys/vehicle/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑限制具体值
    async editLimit (param, id){
        let url = `/api/sys/firmware/${id}/limit`
        let result = await this.getData(url,param,'PUT')
        return result
    }
}

export {
    FirmwareApi
}